var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 179,
    viewBox: "0 0 192 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.2518 114.024V86.6905C68.2518 82.9166 71.2863 79.8571 75.0295 79.8571H122.474C126.217 79.8571 129.252 82.9166 129.252 86.6905V114.024C129.252 117.797 126.217 120.857 122.474 120.857H75.0295C71.2863 120.857 68.2518 117.797 68.2518 114.024Z",
    stroke: "#777777",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2518 79.8571V66.2571C78.2518 54.9905 87.4299 45.8571 98.7518 45.8571C110.074 45.8571 119.252 54.9905 119.252 66.2571V79.8571",
    stroke: "#777777",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.261 116.643L177.454 109.821L184.252 137.107",
    stroke: "#777777",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.454 109.821C171.673 127.153 160.771 142.309 146.2 153.275C131.629 164.241 114.077 170.498 95.8766 171.214C79.1277 171.217 62.7837 166.048 49.0648 156.406C35.3459 146.765 24.9168 133.121 19.1943 117.325",
    stroke: "#777777",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4922 62.0714L14.2998 68.8929L7.50177 41.6071",
    stroke: "#777777",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2998 68.8929C20.3851 51.751 31.3668 36.7873 45.8745 25.869C60.3821 14.9509 77.7731 8.5621 95.8768 7.5C112.707 7.54748 129.111 12.8174 142.839 22.5874C156.569 32.3573 166.949 46.1488 172.559 62.0714",
    stroke: "#777777",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadPassword);
export default __webpack_public_path__ + "static/media/reload-password.3b2e3be06e820cc0b0aa5aafe9f1c8db.svg";
export { ForwardRef as ReactComponent };